import React from "react";
import { ThemedDialog } from "ui-components";
import { Classes, IconName } from "@blueprintjs/core";
import { match } from "ts-pattern";

import { ActiveAttachmentT } from ".";
import { AssetTextContent } from "./asset-text-content";

type AttachmentDialogProps = {
  attachmentOpened: ActiveAttachmentT | undefined;
  handleCloseIsAttachmentOpen: () => void;
};

const AttachmentDialog = ({
  handleCloseIsAttachmentOpen,
  attachmentOpened,
}: AttachmentDialogProps) => {
  return (
    <ThemedDialog
      isOpen={!!attachmentOpened}
      onClose={handleCloseIsAttachmentOpen}
      title={attachmentOpened?.attachment.description}
      icon={attachmentOpened?.icon as IconName}
      style={{ width: "fit-content" }}
    >
      <div className={Classes.DIALOG_BODY}>
        {match(attachmentOpened?.contentType as string | undefined)
          .with(
            "image/bmp",
            "image/gif",
            "image/jpeg",
            "image/png",
            "image/tiff",
            "image/webp",
            () => {
              const src = attachmentOpened
                ? attachmentOpened.getAssetUrlQuery({
                    attachment: false,
                    compressed: false,
                  })
                : undefined;

              return (
                <img
                  height="auto"
                  width="auto"
                  alt={attachmentOpened?.altText}
                  title={attachmentOpened?.altText}
                  src={src}
                  style={{
                    maxHeight: "50vh",
                    maxWidth: "80vw",
                  }}
                />
              );
            }
          )
          .with("application/pdf", (contentType) => (
            <object
              aria-label={attachmentOpened?.altText}
              type={contentType}
              data={attachmentOpened?.getAssetUrlQuery({
                attachment: false,
                compressed: false,
              })}
            />
          ))
          .with(
            "application/json",
            "text/csv",
            "text/plain",
            "text/rtf",
            "text/tab-separated-values",
            (contentType) => {
              if (
                !attachmentOpened?.assetProperties ||
                !attachmentOpened?.getAssetUrlQuery
              ) {
                return null;
              }
              return (
                <AssetTextContent
                  contentType={contentType}
                  assetProperties={attachmentOpened?.assetProperties}
                  getAssetUrlQuery={attachmentOpened?.getAssetUrlQuery}
                />
              );
            }
          )
          .with("application/zip", () => null)
          .with(undefined, () => null)
          .otherwise(() => null)}
      </div>
    </ThemedDialog>
  );
};

export default AttachmentDialog;
